import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import ProgressBar from '@components/ProgressBar';
import Icons from '@icons';
import { shortFileName } from '@common/util';
import { fileIconBasedOnFileName } from '@container/WorkkardDetail/utils';
import { getAuthHeaders } from '../../../../utils/authManager';

const PREVIEW_HEIGHT = 500;
const PREVIEW_WIDTH = 500;

function fetchPreview(guid) {
  return axios.get(`${process.env.core_gateway_url}/1.0/preview`, {
    headers: getAuthHeaders(),
    params: { guid, height: PREVIEW_HEIGHT, width: PREVIEW_WIDTH },
    responseType: 'blob',
  });
}

function FileRow({ data, itemIndex, onUpdateCaption, onRemove }) {
  const [progress, setProgress] = useState(0);
  const [previewSrc, setPreviewSrc] = useState(null);
  const intervalRef = useRef(null);

  const nameExt = (() => {
    const parts = String(data.name || '').split('.');
    return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
  })();
  const iconName = fileIconBasedOnFileName(nameExt);
  const isImage = iconName === 'Image';

  useEffect(() => {
    if (data.isLoading) {
      intervalRef.current = setInterval(() => {
        setProgress((p) => (p < 98 ? p + 2 : p));
      }, 700);
    }
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [data.isLoading]);

  useEffect(() => {
    if (data.isLoading || !data.guid || !isImage) return undefined;

    let objectUrl = null;
    let cancelled = false;
    setPreviewSrc(null);

    fetchPreview(data.guid)
      .then((response) => {
        if (cancelled) return;
        objectUrl = window.URL.createObjectURL(response.data);
        setPreviewSrc(objectUrl);
      })
      .catch(() => {});

    return () => {
      cancelled = true;
      if (objectUrl) window.URL.revokeObjectURL(objectUrl);
    };
  }, [data.isLoading, data.guid, isImage]);

  if (data.isLoading) {
    return (
      <li key={`${data.fileName}_${itemIndex}`}>
        <div className="uploadImage progressUpload">{`${progress}%`}</div>
        <div className="uploadImageInfo flexGrow">
          <div className="uploadedInfo">
            <span className="fileName" title={data.fileName}>{shortFileName(data.fileName)}</span>
            <ProgressBar percentage={progress} progressBarType="SuccessFile" />
          </div>
          <div className="alignMiddle" onClick={() => onRemove(data)}>
            <Icons name="closeFilled" className="icon close" />
          </div>
        </div>
      </li>
    );
  }

  return (
    <li key={`${data.guid || data.name}_${itemIndex}`}>
      <div className="uploadImage attachment">
        {isImage && previewSrc
          ? (
            <img
              src={previewSrc}
              alt={data.name}
              onError={() => setPreviewSrc(null)}
            />
          )
          : <Icons name={iconName} />}
      </div>
      <div className="uploadImageInfo">
        <span
          className="fileName"
          title={data.name}
        >
          {data.name}
        </span>
        <input
          type="text"
          maxLength={180}
          placeholder="Type your caption here..."
          value={data.caption || ''}
          onChange={(e) => onUpdateCaption(data.guid, e.target.value)}
          onBlur={(e) => onUpdateCaption(data.guid, (e.target.value || '').trim())}
        />
        <div onClick={() => onRemove(data)}>
          <Icons name="closeFilled" className="icon close" />
        </div>
      </div>
    </li>
  );
}

export default FileRow;
